import config from '../client-config.js';

export const projectId = config.projectId;
const euProjectIds = ['lvs-prod-eu', 'lvs-stage-eu'];
export const isEuProject = euProjectIds.includes(projectId);

export const isEmulator = !!config.useFirebaseEmulators;
export const isProduction = projectId === 'lcpro-9cc17' || projectId === 'lvs-prod-eu';
export const isStage = (projectId === 'linoleum-35588' || projectId === 'lvs-stage-eu') && !isEmulator;
export const isDev = projectId && (projectId.startsWith('liveshopping-dev-') || projectId.startsWith('bamls-dev-'));
export const projectIdWithEnv = () => {
  if (isEmulator) return `EMULATOR: ${projectId}`;
  if (isStage) return `STAGE: ${projectId}`;
  if (isDev) return `DEV: ${projectId}`;
  return `PROD: ${projectId}`;
};
